import { useMutation } from '@tanstack/react-query';
import { deleteManyPractices } from '../queries/post';

export function useDeleteManyPractices() {
  const { mutate, data, isPending, isSuccess } = useMutation({
    mutationKey: ['deleteManyPractices'],
    mutationFn: (ids: string[]) => deleteManyPractices(ids),
    retry: false,
  });

  return { mutate, data, isPending, isSuccess };
}
